import {
  AfterViewInit,
  Component,
  OnInit,
  Renderer2,
  OnDestroy,
  ViewChild,
  DestroyRef,
  inject,
  Inject,
  HostListener,
} from '@angular/core';
import {
  Scorecard,
  ScorecardDisplayType,
  DATE_OPTIONS,
  DateOptions,
  ScorecardService,
  ScorecardDescription,
  ScorecardQuery,
} from '@fgb/core';
import * as confettiLib from 'canvas-confetti';
import { distinctUntilChanged, finalize, map, startWith, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ScorecardDescriptionHeaderComponent } from './scorecard-description-header/scorecard-description-header.component';
import { HideMobileNav, HideMobileFooterDirective } from '@fgb/portal-component-library/src/lib/directives';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, Subscription } from 'rxjs';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'fgbcl-scorecard-description',
  templateUrl: './scorecard-description.component.html',
  styleUrl: './scorecard-description.component.scss',
  hostDirectives: [HideMobileNav, HideMobileFooterDirective],
})
export class ScorecardDescriptionComponent implements OnInit, AfterViewInit, OnDestroy {
  scorecard: Scorecard;
  parentScorecard: Scorecard;
  childScoreCard: Scorecard;
  scorecardFamily: Scorecard[];
  linkedScorecardLength: number;
  currentScorecardIndex: number;
  confettiColors: string[] | undefined = undefined; //Add strings of hex color ex: ['#000','#fff']
  scorecardDisplayType = ScorecardDisplayType;
  childScorecardIndex: number;
  parentScorecardIndex: number;
  myContext: any;
  preventMultipleClick: boolean = false;
  scorecardId: number;
  @ViewChild(ScorecardDescriptionHeaderComponent, { static: false })
  scorecardDescriptionHeader: ScorecardDescriptionHeaderComponent;
  destroyRef = inject(DestroyRef);
  isSponsorInBody: boolean = false;
  subcription$: Subscription;
  intervalConfetti: ReturnType<typeof setInterval>;
  isMobile: boolean = false;
  constructor(
    private renderer2: Renderer2,
    private scorecardService: ScorecardService,
    private activatedRoute: ActivatedRoute,
    private scorecardQuery: ScorecardQuery,
    private router: Router,
    private offcanvasService: NgbOffcanvas,
    @Inject(DATE_OPTIONS) public dateOption: DateOptions
  ) {}

  ngOnInit() {
    this.checkScreenWidth();
    this.initScorecardDescription();
    let id = this.activatedRoute.snapshot.paramMap.get('id') as any;

    this.isSponsorInBody = (this.activatedRoute.snapshot.paramMap.get('isSponsorInBody') as any) || false;
    if (!id) {
      id = this.scorecardId;
    }
    this.fetchScorecard(+id);

    fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth),
        map(() => window.innerWidth <= 576),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((isMobile) => {
        if (!isMobile && this.router.url.startsWith('/scorecard-description')) {
          this.router.navigate(['/challenges', { scorecardId: id }]);
        } else if (isMobile && (this.router.url.startsWith('/challenges') || this.router.url === '/')) {
          this.offcanvasService.dismiss();
          let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};
          this.router.navigate(['/scorecard-description', id, params]);
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  checkScreenWidth() {
    this.isMobile = window.innerWidth < 577;
  }

  initScorecardDescription() {
    this.scorecardService.initDataScorecardDescription$
      .subscribe((initVal) => {
        this.confettiColors = initVal.confettiColors;
      })
      .unsubscribe();
  }

  fetchScorecard(id: number) {
    this.scorecardService
      .fetchScorecardBy(id)
      .pipe(
        take(1),
        finalize(() => {
          this.getContextForNextChallenge();
        })
      )
      .subscribe((scorecards) => {
        if (scorecards?.length == 0) this.router.navigate(['/404page']);
        this.linkedScorecardLength = scorecards.length;
        this.preventMultipleClick = false;
        this.identifyScorecard(scorecards, id);
      });
  }

  identifyScorecard(scorecards: Scorecard[], idCurrentScorecard: number) {
    this.subcription$ = this.scorecardQuery
      .selectEntity(idCurrentScorecard)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((currentScorecard) => {
        if (!currentScorecard) return;
        this.scorecardFamily = [...scorecards];
        this.scorecard = currentScorecard as Scorecard;
        this.parentScorecard = this.scorecardService.findScorecard(scorecards, currentScorecard.ParentId);
        this.childScoreCard = this.scorecardService.findScorecard(scorecards, currentScorecard.ChildId);
        this.childScorecardIndex = this.scorecardService.findScorecardIndex(scorecards, currentScorecard.ChildId);
        this.parentScorecardIndex = this.scorecardService.findScorecardIndex(scorecards, currentScorecard.ParentId);
        this.currentScorecardIndex = this.scorecardService.findScorecardIndex(scorecards, currentScorecard.ScorecardId);
        this.isCompleted && this.shootConfetti();
      });
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  get showLinkedScoreCard(): boolean {
    return this.hasChild || this.hasParent;
  }

  get isCompleted(): boolean {
    return this.scorecard?.Completed;
  }

  get hasChild(): boolean {
    return !!this.scorecard?.ChildId;
  }

  get hasParent(): boolean {
    return !!this.scorecard?.ParentId;
  }

  get isLocked(): boolean {
    return !!this.scorecard?.Locked;
  }

  get isLastChildUnlocked(): boolean {
    return this.hasParent && !this.hasChild && !this.isLocked;
  }

  get hasPrizeSelection(): boolean {
    return !!this.scorecard.PrizeOptions;
  }

  get scorecardDescription(): ScorecardDescription {
    return {
      currentScorecard: this.scorecard,
      parentScorecard: this.parentScorecard,
      childScoreCard: this.childScoreCard,
      scorecardFamily: this.scorecardFamily,
      linkedScorecardLength: this.linkedScorecardLength,
      currentScorecardIndex: this.currentScorecardIndex,
      showLinkedScoreCard: this.showLinkedScoreCard,
      isCompleted: this.isCompleted,
      isLocked: this.isLocked,
      hasChild: this.hasChild,
      hasParent: this.hasParent,
    };
  }

  //Return name of prize has selected = true
  get prizeSelected(): string | undefined {
    if (this.scorecard.PrizeOptions && Object.keys(this.scorecard.PrizeOptions).length == 0) return '';
    let prizeSelected = this.scorecard.PrizeOptions?.Prizes.find((prize) => prize.Selected);
    return prizeSelected?.PrizeTitle;
  }
  //If scorecard has completed but not select prize yet, disable show more button
  get invisibleShowMore() {
    if (this.isCompleted && this.scorecard.PrizeOptions && !this.scorecard.PrizeOptions?.CustomerHasSelected) return false;
    else {
      return true;
    }
  }

  getContextForNextChallenge() {
    // Completed scorecard have child
    if (this.isCompleted && this.hasChild) {
      this.createContext(
        'scorecard.description.modal.next.challenge',
        this.childScoreCard?.Image,
        this.childScoreCard?.Content[0].Name,
        true,
        this.childScoreCard,
        this.childScorecardIndex,
        true
      );
    }

    // Incompleted scorecard have child
    if (!this.isCompleted && !this.isLocked && this.hasChild) {
      this.createContext(
        'scorecard.description.modal.next.challenge',
        this.childScoreCard?.Image,
        this.childScoreCard?.Content[0]?.Name,
        false,
        this.childScoreCard,
        this.childScorecardIndex,
        true
      );
    }

    // Child scorecard has been locked
    if (this.hasParent && this.isLocked) {
      this.createContext(
        'scorecard.description.modal.complete.first',
        this.parentScorecard?.Image,
        this.parentScorecard?.Content[0].Name,
        true,
        this.parentScorecard,
        this.parentScorecardIndex,
        false
      );
    }
    // scorecard has been locked and has parent locked
    if (this.hasParent && this.parentScorecard.Locked && this.isLocked) {
      this.createContext(
        'scorecard.description.modal.complete.first',
        this.parentScorecard?.Image,
        this.parentScorecard?.Content[0].Name,
        false,
        this.parentScorecard,
        this.parentScorecardIndex,
        false
      );
    }
  }

  createContext(
    label: string,
    image: string,
    name: string,
    invisibleIcon: boolean,
    scorecard: Scorecard,
    scorecardIndex: number,
    isDirectToChild: boolean
  ) {
    this.myContext = {
      label: label,
      image: image,
      name: name,
      invisibleIcon: invisibleIcon,
      openScorecard: () => this.openScorecard(scorecard, scorecardIndex, isDirectToChild),
    };
  }

  onPreviousClick(isMovePosition: boolean = false) {
    isMovePosition && (this.scorecardDescriptionHeader.currentPosition += 55);
    this.openScorecard(this.parentScorecard, this.parentScorecardIndex, false);
  }

  onNextClick(isMovePosition: boolean = false) {
    isMovePosition && (this.scorecardDescriptionHeader.currentPosition -= 55);
    this.openScorecard(this.childScoreCard, this.childScorecardIndex, true);
  }

  openScorecard(scorecard: Scorecard, scorecardIndex: number, isDirectToChild: boolean) {
    if (!scorecard || this.preventMultipleClick) return;
    this.preventMultipleClick = true;
    this.subcription$.unsubscribe();
    this.identifyScorecard(this.scorecardFamily, scorecard.ScorecardId);
    this.preventMultipleClick = false;
    this.removeConfetti();
  }

  shootConfetti() {
    const canvas = this.renderer2.createElement('canvas');
    this.renderer2.addClass(canvas, 'confetti');
    let backdrop: any;
    if (window.screen.width > 991) {
      setTimeout(() => {
        backdrop = document.querySelector('ngb-offcanvas-panel.scorecard-offcanvas-content');
      });
    } else {
      backdrop = document.querySelector('.scorecard-description-page');
    }
    setTimeout(() => {
      this.renderer2.appendChild(backdrop, canvas);
      this.initConfetti(7, canvas);
    });
  }

  removeConfetti() {
    let canvas = document.querySelector('canvas');
    if (canvas) {
      clearInterval(this.intervalConfetti);
      canvas?.remove();
    }
  }

  initConfetti(duration: number, element: any) {
    let confetti = this.createConfetti(element);
    let timeFiring = duration * 1000;
    let animationEnd = Date.now() + timeFiring;
    let colors = this.confettiColors?.length ? this.confettiColors : undefined;
    let defaults = { startVelocity: 30, spread: 360, ticks: 60, colors: colors };

    this.intervalConfetti = setInterval(() => {
      let timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) {
        element?.remove();
        return clearInterval(this.intervalConfetti);
      }
      let particleCount = 300 * (timeLeft / timeFiring);
      confetti(
        Object.assign({}, defaults, { particleCount, origin: { x: this.randomInRange(0.1, 0.3), y: Math.random() - 0.4 } })
      );
      confetti(
        Object.assign({}, defaults, { particleCount, origin: { x: this.randomInRange(0.7, 0.9), y: Math.random() - 0.2 } })
      );
    }, 500);
  }

  randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  createConfetti(element: any) {
    return confettiLib.create(element, {
      resize: true,
    });
  }
}
